import fetchClient from './fetchClient';
import { errorHandler } from './utils';

const config = () => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});

// ---- CRUD ZONES ----

// GET all zones
export const getZones = async () => {
  const res: any = await fetchClient.get("/zones", config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// CREATE a zone
export const createZone = async (zone: { name: string }) => {
  const res: any = await fetchClient.post("/zones", zone, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// UPDATE a zone
export const updateZone = async (id: string, zone: { name: string }) => {
  const res: any = await fetchClient.put(`/zones/${id}`, zone, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};

// DELETE a zone
export const deleteZone = async (id: string) => {
  const res: any = await fetchClient.delete(`/zones/${id}`, config()).catch(errorHandler);
  if (!res) return null;
  return res.data;
};
